import { Link } from "react-router-dom";
import { CONTENT } from "@/content";

const F = CONTENT.footer;

export const Footer = () => (
  <footer className="nb-bar footer-bar" data-testid="site-footer">
    <p className="footer-line" data-testid="footer-sign-off">{F.signOff}</p>
    <div className="footer-links">
      {F.links.map((l) => <Link key={l.to} to={l.to} className="footer-link" data-testid={l.testId}>{l.label}</Link>)}
    </div>
    <p className="footer-copy" data-testid="footer-copyright">{F.copyright(new Date().getFullYear())}</p>
  </footer>
);
